export type FileData = {
  id: string;
  link: string;
  name: string;
};

export enum FILE_MANAGE_ORDER {
  UPLOAD = 1,
  REMOVE = 2,
}

export type IconFunctions = {
  component: any;
  function: () => void;
};

export type PhotoPanelData = {
  title?: string;
  caption: string;
  files?: FileData | null;
  disabled: boolean;
  onPhotoBaseChange: (newBase: string) => void;
  handleFilesChange: (order: number, id: string) => void;
  setLoading?: (loading: boolean) => void;
};
